import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { H2, H4 } from '../../../components';
import { FormattedMessage } from 'react-intl';

import css from './SectionHowItWorks.module.css';

const SectionHowItWorks = props => {
  const { rootClassName, className } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <H2 className={css.title}>
        <FormattedMessage id="LawyerLandingPage.SectionHowItWorks.title" />
      </H2>
      <p className={css.subtitle}>
        <FormattedMessage
          id="LawyerLandingPage.SectionHowItWorks.subtitle"
          values={{ br: () => <br /> }}
        />
      </p>
      <p className={css.contextLine}>
        <FormattedMessage
          id="LawyerLandingPage.SectionHowItWorks.contextLine"
          values={{ b: text => <strong>{text}</strong> }}
        />
      </p>
      <div className={css.sectionHowItWorks}>
        <div className={css.item}>
          <H4>
            <FormattedMessage id="LawyerLandingPage.SectionHowItWorks.column1Title" />
          </H4>
          <p>
            <FormattedMessage
              id="LawyerLandingPage.SectionHowItWorks.column1Content"
              values={{ b: text => <strong>{text}</strong> }}
            />
          </p>
        </div>

        <div className={css.item}>
          <H4>
            <FormattedMessage id="LawyerLandingPage.SectionHowItWorks.column2Title" />
          </H4>
          <p>
            <FormattedMessage
              id="LawyerLandingPage.SectionHowItWorks.column2Content"
              values={{ b: text => <strong>{text}</strong> }}
            />
          </p>
        </div>

        <div className={css.item}>
          <H4>
            <FormattedMessage id="LawyerLandingPage.SectionHowItWorks.column3Title" />
          </H4>
          <p>
            <FormattedMessage
              id="LawyerLandingPage.SectionHowItWorks.column3Content"
              values={{ b: text => <strong>{text}</strong> }}
            />
          </p>
        </div>
      </div>
    </div>
  );
};

SectionHowItWorks.defaultProps = { rootClassName: null, className: null };

SectionHowItWorks.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHowItWorks;
